import { render, staticRenderFns } from "./LoginSuccess.vue?vue&type=template&id=195bb554&scoped=true&"
import script from "./LoginSuccess.vue?vue&type=script&lang=js&"
export * from "./LoginSuccess.vue?vue&type=script&lang=js&"
import style0 from "./LoginSuccess.vue?vue&type=style&index=0&id=195bb554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195bb554",
  null
  
)

export default component.exports